import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=5c905c81&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=5c905c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c905c81",
  null
  
)

export default component.exports